import React, { useState } from "react";
import BackCurtain from "../../../../BackCurtain";
import { IoMdClose } from "react-icons/io";
import formStyles from "./newFlowForm.module.css";
import FeedbackTemplate from "./TemplatesForm/FeedbacksForm";

const NewFlowForm = ({ elementName, brand, flowName, onValidate, close }) => {
  const [newBrand, setBrand] = useState(brand);
  const [newFlowName, setFlowName] = useState(flowName);
  const [newFlowVersion, setFlowVersion] = useState("");
  const [newFlowTemplate, setFlowTemplate] = useState("empty");
  const [formErrors, setFormErrors] = useState([]);
  const app =
    (new URL(window.location.href).pathname.match(/\/([^/]+)/) || [])[1] ||
    null;

  const TEMPLATE_COMPONENTS = {
    feedbacks: FeedbackTemplate,
  };

  const TemplateFormComponent = TEMPLATE_COMPONENTS[newFlowTemplate];

  const handleValidateButtonClick = function () {
    setFormErrors([]);
    let invalidForm = false;

    if (!newBrand.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "brand", message: "Brand filed is required" },
      ]);
      invalidForm = true;
    }
    if (!newFlowName.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "flowName", message: "Flow name field is required" },
      ]);
      invalidForm = true;
    }
    if (!newFlowVersion.length) {
      setFormErrors((prev) => [
        ...prev,
        { field: "flowVersion", message: "Flow version field is required" },
      ]);
      invalidForm = true;
    }

    if (invalidForm) {
      return;
    }

    onValidate({
      brand: newBrand,
      name: newFlowName,
      version: newFlowVersion,
    });
  };

  return (
    <div>
      <BackCurtain />

      <div className={formStyles.form_container}>
        <div className={formStyles.close_button_container}>
          <span
            className={formStyles.close_button}
            onClick={() => close(false)}
          >
            <IoMdClose />
          </span>
        </div>
        <div className={formStyles.form_control}>
          <div className={formStyles.form_label}>
            <label>Brand</label>
          </div>
          <input
            type="text"
            value={newBrand}
            autoFocus={elementName === "brand"}
            onChange={(e) => setBrand(e.target.value)}
          />
        </div>
        <div className={formStyles.form_control}>
          <div className={formStyles.form_label}>
            <label>Name</label>
          </div>
          <input
            type="text"
            value={newFlowName}
            autoFocus={elementName === "name"}
            onChange={(e) => setFlowName(e.target.value)}
          />
        </div>
        <div className={formStyles.form_control}>
          <div className={formStyles.form_label}>
            <label>Version</label>
          </div>
          <input
            type="text"
            value={newFlowVersion}
            autoFocus={elementName === "version"}
            onChange={(e) => setFlowVersion(e.target.value)}
          />
        </div>
        {app === "web-app" ? (
          <div className={formStyles.form_control}>
            <div className={formStyles.form_label}>
              <label>Template</label>
            </div>
            <select
              id="template"
              name="template"
              onChange={(e) => setFlowTemplate(e.target.value)}
              value={newFlowTemplate}
            >
              <option value="empty">Empty</option>
              <option value="feedbacks">Feedbacks template</option>
            </select>
          </div>
        ) : (
          ""
        )}
        {TemplateFormComponent ? (
          <TemplateFormComponent
            brand={newBrand}
            flowName={newFlowName}
            flowVersion={newFlowVersion}
            onValidate={onValidate}
            setFormErrors={setFormErrors}
          />
        ) : (
          <div className={formStyles.validate_button_container}>
            <button
              className={formStyles.validate_button}
              onClick={handleValidateButtonClick}
            >
              Create
            </button>
          </div>
        )}

        <div className={formStyles.warning_zone}>
          {formErrors.map((error) => (
            <div key={error.field}>{error.message}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewFlowForm;
